import React, { Fragment } from 'react';
import PropTypes from "prop-types";

import './SocialNetworkIcon.css';

const calculateNetwork = (network, url) => {
  let value = 'default';
  if (network) {
    value = network;
  } else if (url) {
    if (url.includes('@')) { value = 'mail'; }
    if (url.includes('instagram.com')) { value = 'instagram'; }
    if (url.includes('facebook.com')) { value = 'facebook'; }
    if (url.includes('youtube.com')) { value = 'youtube'; }
    if (url.includes('twitter.com')) { value = 'twitter'; }
    if (url.includes('soundcloud.com')) { value = 'soundcloud'; }
    if (url.includes('linkedin.com')) { value = 'linkedin'; }
    if (url.includes('twitch.tv')) { value = 'twitch'; }
    if (url.includes('patreon.com')) { value = 'patreon'; }
    if (url.includes('pinterest.com')) { value = 'pinterest'; }
    if (url.includes('tiktok.com')) { value = 'tiktok'; }
    if (url.includes('spotify.com')) { value = 'spotify'; }
    if (url.includes('amazon.com')) { value = 'amazon'; }
    if (url.includes('google.com')) { value = 'google'; }
    if (url.includes('telegram.me')) { value = 'telegram'; }
    if (url.includes('snapchat.com')) { value = 'snapchat'; }
    if (url.includes('shopee')) { value = 'shopee'; }
    if (url.includes('music.apple.com')) { value = 'apple music'; }
    if (url.includes('podcasts.apple.com')) { value = 'apple podcast'; }
    if (url.includes('poshmark.com')) { value = 'poshmark'; }
    if (url.includes('dribbble.com')) { value = 'dribbble'; }
    if (url.includes('behance.net')) { value = 'behance'; }
    if (url.includes('etsy.com')) { value = 'etsy'; }
    if (url.includes('beatstars.com')) { value = 'beatstars'; }
    if (url.includes('audiomack.com')) { value = 'audiomack'; }
    if (url.includes('venmo.com')) { value = 'payment'; }
  }
  return value;
};

const final_url = url => {
  if (url.includes('@') && !url.includes('tiktok') ) {
    return `mailto:${url}`;
  }
  return url;
};

const SocialNetworkIcon = ({ network, url, link }) => {
  return (
    <Fragment>
      {(link && url) ?
        <a
          className={`social-network-icon__component${link ?
            ' link' : ''} ${calculateNetwork(network, url)}`}
          href={final_url(url)}
          rel="noreferrer noopener"
          target="_blank"
        />
        :
        <div
          className={`social-network-icon__component${link ?
            ' link' : ''} ${calculateNetwork(network, url)}`}
        />
      }
    </Fragment>
  );
};

SocialNetworkIcon.propTypes = {
  network: PropTypes.string,
  url: PropTypes.string,
  link: PropTypes.bool,
};

SocialNetworkIcon.defaultProps = {
  network: null,
  url: null,
  link: null,
};

export default SocialNetworkIcon;
